/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import moment from 'moment';

import { getLocalTimeZone } from '@/utils/date';

import { REQUEST_TYPES } from './constants';

export const isValidNumber = (value) => {
  return value && value !== '' && !Number.isNaN(value) ? Number(value) : 0;
};

export const getShipmentDetails = (shipmentData = {}) => {
  const {
    isLoadedDelivered = false,
    isLoadedPickUp = false,
    isEmptyDelivered = false,
    isEmptyPickUp = false,
  } = shipmentData;

  const isMultiple = (isEmptyDelivered || isLoadedDelivered) && (isEmptyPickUp || isLoadedPickUp);
  const pickupStatus = isLoadedPickUp ? 'Loaded' : 'Empty';
  const deliveryStatus = isLoadedDelivered ? 'Loaded' : 'Empty';
  const pickupLabel = `Pickup ${pickupStatus}`;
  const deliveryLabel = `Delivery ${deliveryStatus}`;

  const nonMultiLabel = isLoadedPickUp
    ? 'Pickup Loaded'
    : isEmptyPickUp
      ? 'Pickup Empty'
      : isLoadedDelivered
        ? 'Delivery Loaded'
        : 'Delivery Empty';

  const nonMultiStatus = nonMultiLabel.includes('Loaded') ? 'Loaded' : 'Empty';

  return {
    deliveryLabel,
    deliveryStatus,
    isMultiple,
    nonMultiLabel,
    nonMultiStatus,
    pickupLabel,
    pickupStatus,
  };
};

export const createShipmentData = ({
  createdBy,
  shipmentNumber,
  companyId,
  branchKey,
  poNumberValue,
  soNumberValue,
  requestID,
  trailerId,
  shipmentOriginInformation,
  shipmentDestinationInformation,
  shipmentProductInformation,
  formValues,
}) => {
  const expShipDate = formValues.orgLocations[0].orgETD;
  const expDeliveryDate = formValues.destLocations[0].destETA;
  return {
    adhocCarrierName: '',
    isCollectBol: 0,
    purchaseSalesOrderInformation: [],
    shipmentAccessorialInformation: [],
    shipmentBillToRequestInformation: {
      address1: '',
      address2: '',
      city: '',
      contact: '',
      contactEmail: '',
      countryCode: '',
      countryName: '',
      createdBy,
      name: '',
      postalCode: '',
      shipmentKey: 0,
      stateCode: '',
      stateName: '',
      vatNumber: '',
    },
    shipmentCategoryInformation: [],
    shipmentDestinationInformation,
    shipmentDocumentInformation: [],
    shipmentInformationRequest: {
      accountNumber: '',
      adhocCarrierName: '',
      approvalNumber: '',
      bolNumber: '',
      branchKey,
      cargoType: '',
      carrierKey: '',
      carrierRequirements: '',
      createdBy: 0,
      currencyCode: '',
      customerContact: '',
      customerKey: companyId,
      detailNotes: '',
      expDeliveryDate: expDeliveryDate || null,
      expShipDate: expShipDate || null,
      fobCode: '',
      freightAllowance: '',
      incoCode: '',
      incoPoint: '',
      masterBolNumber: '',
      masterShipment: 0,
      masterShipmentCurrentQty: 0,
      masterShipmentCurrentWeight: 0,
      paidAmount: 0,
      paymentTerms: '',
      projectNo: '',
      proNo: '',
      purchaseOrderNumber: poNumberValue,
      quoteNo: '',
      rateShopCost: 0,
      rateShopKey: 0,
      rateType: '',
      requiredCarrierKey: 0,
      salesOrderNumber: soNumberValue,
      serviceKey: 0,
      shipmentKey: 0,
      shipmentNo: shipmentNumber,
      shipmentNotes: '',
      shipmentTerms: 'P',
      shipmentType: REQUEST_TYPES.INBOUND.value,
      specialServices: '',
      status: 'New',
      trackingDateTime: null,
      trailerId,
      trailerNumber: formValues.selTrailer,
      trailerRequestID: requestID,
      transportationMode: '',
      yardID: formValues.selYardValue || 0,
    },
    shipmentOriginInformation,
    shipmentProductInformation,
    shipmentRateShopInformation: [],
    shipmentTaxInformation: [],
    shipmentVendorRequestInformation: [],
    userId: createdBy,
  };
};

export const OriginDataBuilder = (data, userID) => {
  return data.map((element) => {
    return {
      addr1: !element.orgaddress1 ? 'NS' : element.orgaddress1,
      addr2: '',
      city: !element.orgcity ? 'NS' : element.orgcity,
      countryCode: !element.orgcountry ? 'NS' : element.orgcountry,
      countryName: '',
      createdBy: userID,
      customerKey: 0,
      displaySequence: 1,
      gridOperation: 1,
      isResetNew: 0,
      legNumber: 0,
      name: element.orgname,
      oldStopSequence: 0,
      originKey: 0,
      portName: '',
      portRecKey: 0,
      portType: '',
      searchId: !element.orgcustref ? '' : element.orgcustref,
      sequence: 1,
      shipmentKey: 0,
      shipmentOriginAdditionalInformation: {
        appointmentType: '',
        carrierActualDeliveryDate: null,
        carrierActualShipDate: null,
        carrierAppontmentDeliveryDate: null,
        carrierAppontmentShipDate: null,
        contactEmail: '',
        contactName: '',
        createdBy: userID,
        displaySequence: 1,
        dockNumber: '',
        doorDockID: '',
        extension: '',
        gridOperation: 1,
        hoursOfOperation: '',
        isResetNew: 0,
        legMiles: 0,
        oldStopSequence: 0,
        phone: '',
        pickupDeliveryID: '',
        sequence: 1,
        shipmentKey: 0,
        shipperRequestedDeliveryDate: null,
        shipperRequestedShipDate: moment.tz(getLocalTimeZone()),
        taxId: '',
        uom: '',
      },
      shipRecKey: 0,
      state: !element.orgstate ? 'NS' : element.orgstate,
      stateName: '',
      stopType: '1',
      trailerNumber: '',
      zip: !element.orgzip ? 'NS' : element.orgzip,
    };
  });
};

export const DestinationDataBuilder = (data, userID) => {
  return data.map((element) => ({
    addr1: !element.destaddress1 ? 'NS' : element.destaddress1,
    addr2: '',
    city: !element.destcity ? 'NS' : element.destcity,
    countryCode: !element.destcountry ? 'NS' : element.destcountry,
    countryName: '',
    createdBy: userID,
    customerKey: 0,
    destinationKey: 0,
    displaySequence: element.seqVal || 99,
    gridOperation: 1,
    isResetNew: 0,
    legNumber: 0,
    name: element.destname,
    oldStopSequence: 0,
    portName: '',
    portRecKey: 0,
    portType: '',
    searchId: !element.destcustref ? '' : element.destcustref,
    sequence: element.seqVal || 99,
    shipmentDestinationAdditionalInformation: {
      appointmentType: '',
      carrierActualDeliveryDate: null,
      carrierActualShipDate: null,
      carrierAppontmentDeliveryDate: null,
      carrierAppontmentShipDate: null,
      contactEmail: '',
      contactName: '',
      createdBy: userID,
      displaySequence: element.seqVal || 99,
      dockNumber: '',
      doorDockID: '',
      extension: '',
      gridOperation: 1,
      hoursOfOperation: '',
      isResetNew: 0,
      legMiles: 0,
      oldStopSequence: 0,
      phone: '',
      pickupDeliveryID: '',
      sequence: element.seqVal || 99,
      shipmentKey: 0,
      shipperRequestedDeliveryDate: moment.tz(getLocalTimeZone()),
      shipperRequestedShipDate: null,
      taxId: '',
      uom: '',
    },
    shipmentKey: 0,
    shipRecKey: 0,
    state: !element.deststate ? 'NS' : element.deststate,
    stateName: '',
    stopType: '2',
    trailerNumber: '',
    zip: !element.destzip ? 'NS' : element.destzip,
  }));
};

export const BuildProdDetailsInfo = (data, userID) =>
  data.orgLocations.map((element) => {
    return {
      actualWeight: 0,
      billQty: 1,
      billQtyUom: 'LB',
      billQtyUomName: '',
      book: isValidNumber(element.orgBookWeight),
      bookOks: isValidNumber(element.orgBookOks),
      cartonQty: 0,
      cartonUOM: '',
      class: '',
      className: '',
      countryOfOrigin: '',
      crateNo: '',
      createdBy: userID,
      cube: 0,
      deliveryID: '',
      dimUom: 'N',
      dimUomName: '',
      eccn: '',
      gridOperation: 1,
      hazmat: '',
      hazmatUnNo: '',
      height: 0,
      hts: '',
      itemSequenceKey: 0,
      length: 0,
      misc: isValidNumber(element.orgMiscWeight),
      miscOKs: isValidNumber(element.orgMiscOks),
      nmfcNumber: '',
      palletLoadType: 'Non Stackable',
      palletPackageType: '',
      poNumber: '',
      productCode: (data.productType?.value || data.productType)?.toString() || '0',
      productDescription: data.Commodity?.label || data.Commodity || '0',
      quantity: 0,
      reference1: '',
      shipmentDetailsID: 0,
      shipmentKey: 0,
      soft: isValidNumber(element.orgSoftWeight),
      softOks: isValidNumber(element.orgSoftOks),
      soNumber: '',
      stcDescription: '',
      unitMeasure: 'LB',
      unitMeasureName: '',
      unitPrice: 0,
      weight: 0,
      weightUom: 'LB',
      weightUomName: '',
      width: 0,
    };
  });

export const BuildOrgInfo = (data, trailerId) => {
  return data.map((element, index) => {
    const seq = 1 + index * 2;
    return {
      actualEntryDate: moment.tz(getLocalTimeZone()),
      bookOks: isValidNumber(element.orgBookOks),
      bookWeight: isValidNumber(element.orgBookWeight),
      clothOKs: isValidNumber(element.orgSoftOks),
      etd: element.orgETD,
      furniturePieces: isValidNumber(element.orgFurn),
      hardWeight: isValidNumber(element.orgMiscWeight),
      locationId: isValidNumber(element?.orgLocationId),
      miscOKs: isValidNumber(element.orgMiscOks),
      originSequence: seq,
      otherLargeItems: isValidNumber(element.orgOLI),
      sendComplete: false,
      softWeight: isValidNumber(element.orgSoftWeight),
      spotDate: element.orgSpotDate,
      trailerID: trailerId,
      trailerMovementID: 0,
    };
  });
};

export const BuildDestInfo = (data, trailerId) => {
  return data.map((element, index) => {
    const seq = 2 + index * 2;
    return {
      actualEntryDate: moment.tz(getLocalTimeZone()),
      bookOks: isValidNumber(element.destBookOks),
      bookWeight: isValidNumber(element.destBookWeight),
      clothOKs: isValidNumber(element.destSoftOks),
      deliverySequence: seq,
      eta: element.destETA,
      furniturePieces: isValidNumber(element.destFurn),
      hardWeight: isValidNumber(element.destMiscWeight),
      locationId: isValidNumber(element?.destLocationId),
      miscOKs: isValidNumber(element.destMiscOks),
      otherLargeItems: isValidNumber(element.destOLI),
      receiveComplete: false,
      softWeight: isValidNumber(element.destSoftWeight),
      trailerID: trailerId,
      trailerMovementID: 0,
    };
  });
};

export const CreateMovementData = ({
  productType,
  branchKey,
  requestID,
  formValues,
  checkOptions,
  trailerRequest,
  trailerShipping,
  shipmentData,
}) => {
  return {
    trailerMovement: {
      adjusted: true,
      adjustmentComment: formValues?.txtinvJusti,
      adjustmentReasonCodeID: 0,
      adjustmentRefDate: null,
      adjustmentRefID: 0,
      bookCost: 0,
      booksOksTrans: 0,
      bookWeightTrans: 0,
      branchKey: formValues?.orgLocations[0]?.orgLocationId,
      clothWeightTransferred: 0,
      dataOrigin: '',
      deliveryLocationID: formValues?.destLocations[0]?.destLocationId,
      directFromPartner: checkOptions.directFromPartner,
      furnitureCost: 0,
      furniturePiecesTrans: 0,
      IsEmptyDelivered: shipmentData?.isEmptyDelivered || false,
      IsEmptyPickUp: shipmentData?.isEmptyPickUp || false,
      IsLoadedDelivered: shipmentData?.isLoadedDelivered || false,
      IsLoadedPickUp: shipmentData?.isLoadedPickUp || false,
      IsMultiStop: false,
      liveLoad: checkOptions.liveLoad,
      liveUnload: checkOptions.liveUnload,
      merchendiseCost: 0,
      miscCost: 0,
      miscTransferred: 0,
      miscWeightTransferred: 0,
      movementDate: null,
      okTransferred: 0,
      oliCost: 0,
      otherLargeitemsTrans: 0,
      partnerId: formValues.selPartner,
      positionDate: null,
      productType: productType || (formValues?.productType?.value || formValues?.productType)?.toString() || '0',
      recordType: 0,
      refferedToPRM: true,
      rentalTrailer: checkOptions.rentalTrailer,
      rollDoor: checkOptions.rollDoor,
      softCost: 0,
      trailerMovementID: 0,
      trailerNumber: formValues.selTrailer,
      trailerReceivingID: branchKey,
      trailerRequestID: requestID,
      trailerShippingID: formValues?.orgLocations[0]?.orgLocationId,
      trailerTransfer: false,
      transferReportnumber: '',
      transferType: 0,
      unitEmpty: checkOptions.unitEmpty,
      unloadComplete: true,
      unloadCompleteDate: null,
      vendorID: '',
    },
    trailerRequest,
    trailerShipping,
  };
};
